module.exports = __webpack_public_path__ + "img/tks_bilibili.342eee9c.png";